import React from "react";
import PropTypes from "prop-types";

class Content extends React.Component {
  render() {
    const cssClasses = "content";

    return <div className={cssClasses}>{this.props.children}</div>;
  }
}

Content.defaultProps = {
  children: null
};

Content.propTypes = {
  children: PropTypes.node
};

export default Content;
